import styled from 'styled-components'

import { device } from '~/styles/utils'

import OrderSummary from './order-summary.container'

export const OrderSummaryV3 = styled(OrderSummary)`
  && {
    background: none;
    padding: 32px 16px 24px;

    .heading {
      padding: 0 0;
      margin-bottom: 23px;
    }
    .totals {
      border-top: solid 1px rgba(9, 35, 64, 0.2);
    }
    .totals.bottom-border {
      border-bottom: solid 1px rgba(9, 35, 64, 0.2);
    }

    .terms-and-conditions {
      border: 1px solid rgba(9, 35, 64, 0.2);
    }

    @media ${device('notMobile')} {
      padding: 96px 48px 24px;
    }
  }
`
